import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setRulesLoading = (data) => (dispatch) => {
  dispatch({
    type: types.RuleTypes.RULE_SET_LOADING,
    payload: data
  });
};

// on create rules
const setRulesCreateLoading = (data) => (dispatch) => {
  dispatch({
    type: types.RuleTypes.RULE_SET_CREATE_LOADING,
    payload: data
  });
};

// on unmount rules
const unmountAllRuleData = (data) => (dispatch) => {
  dispatch({
    type: types.RuleTypes.RULE_UNMOUNT,
    payload: data
  });
};

// clear result
const clearRulesResult = () => (dispatch) => {
  dispatch({
    type: types.RuleTypes.RULE_CLEAR_RESULT
  });
};

// clear error
const clearRulesErrors = () => (dispatch) => {
  dispatch({
    type: types.RuleTypes.RULE_CLEAR_ERRORS
  });
};

const createRules = (ruleInfo, createdBy, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const ruleCreateSuccess = await axios.post(
      `${baseUrlNode}${api.Rules_Api.CREATE_RULES_API}/${createdBy}`,
      ruleInfo
    );
    const { data } = ruleCreateSuccess;
    dispatch({
      type: types.RuleTypes.CREATE_RULE,
      payload: data
    });
  } catch (ruleCreateError) {
    const errorData = {
      data: ruleCreateError.response.data,
      status: ruleCreateError.response.status
    };
    console.log(errorData);
    dispatch({
      type: types.RuleTypes.RULE_CREATE_GET_ERRORS,
      payload: errorData
    });
  }
};

const activateRule = (rule_id, loginType, editedById) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const ruleActivateSuccess = await axios.post(
      `${baseUrlNode}${api.Rules_Api.RULE_ACTIVATE_API}/${rule_id}/${editedById}`
    );
    const { data } = ruleActivateSuccess;
    dispatch({
      type: types.RuleTypes.RULE_ACTIVATE,
      payload: data
    });
  } catch (ruleActivateError) {
    const errorData = {
      data: ruleActivateError.response.data,
      status: ruleActivateError.response.status
    };
    dispatch({
      type: types.RuleTypes.RULE_GET_ERRORS,
      payload: errorData
    });
  }
};

const deleteRule = (rule_id, loginType, locationId) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const ruleDeleteSuccess = await axios.post(
      `${baseUrlNode}${api.Rules_Api.RULE_DELETE_API}/${locationId}/${rule_id}`
    );
    const { data } = ruleDeleteSuccess;
    dispatch({
      type: types.RuleTypes.DELETE_RULE,
      payload: data
    });
  } catch (ruleDeleteError) {
    const errorData = {
      data: ruleDeleteError.response.data,
      status: ruleDeleteError.response.status
    };
    dispatch({
      type: types.RuleTypes.RULE_GET_ERRORS,
      payload: errorData
    });
  }
};

const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

const getAllRules = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Rules_Api.GET_RULES_API}`;
  const type = types.RuleTypes.GET_RULES;
  const errorType = types.RuleTypes.RULE_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

// get rules by locationId
const getAllRulesByLocationId = (locationId, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Rules_Api.GET_RULES_API}/${locationId}`;
  const type = types.RuleTypes.GET_RULES;
  const errorType = types.RuleTypes.RULE_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const currentUser = (loginType) => async () => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}/api/rule/current`;

  const getRequestSuccess = await axios.get(url);
  console.log(getRequestSuccess);
};

export {
  deleteRule,
  createRules,
  getAllRules,
  currentUser,
  activateRule,
  setRulesLoading,
  clearRulesErrors,
  clearRulesResult,
  unmountAllRuleData,
  setRulesCreateLoading,
  getAllRulesByLocationId
};
